import React from "react";

export const LogoVk = React.forwardRef<SVGSVGElement, React.SVGAttributes<SVGElement>>(function LogoVk(props, ref) {
	return (
		<svg ref={ref} fill="#fff" {...props}>
			<use xlinkHref="#icon-logo_vk"></use>
		</svg>
	);
});
